module.exports = __webpack_public_path__ + "static/img/zf_img_function04.13c0905.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/zf_img_function04.png
// module id = uA2M
// module chunks = 1